import { GET_ACCOUNT_INFO, SIGNUP_NEW_USER, CREATE_CUSTOMER, CREATE_CUSTOMER_SUCCESS, CREATE_CUSTOMER_FAILURE, SIGNUP_NEW_USER_SUCCESS, SIGNUP_NEW_USER_FAILURE, GET_ACCOUNT_INFO_ERROR, GET_ACCOUNT_INFO_SUCCESS, GET_SUBSCRIPTIONS, GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS_ERROR, GET_USERS_SUCCESS, GET_USERS_ERROR, GET_USERS, GET_DASHBOARD, GET_DASHBOARD_SUCCESS, GET_DASHBOARD_ERROR, ADD_DASHBOARD_ITEM, ADD_DASHBOARD_ITEM_SUCCESS, ADD_DASHBOARD_ITEM_ERROR, DELETE_DASHBOARD_ITEM, DELETE_DASHBOARD_ITEM_SUCCESS, DELETE_DASHBOARD_ITEM_ERROR } from "./actionTypes"

export const getUsers = () => {
  return {
    type: GET_USERS,
  }
}

export const fetchUsersSuccess = users => ({
    type: GET_USERS_SUCCESS,
    payload: users,
})

export const signUpNewUser = () => ({
  type: SIGNUP_NEW_USER,
});

export const signUpNewUserSuccess = (sessionId) => ({
  type: SIGNUP_NEW_USER_SUCCESS,
  payload: sessionId,
});

export const signUpNewUserFailure = (error) => ({
  type: SIGNUP_NEW_USER_FAILURE,
  payload: error,
});

export const createCustomer = (profile) => ({
  type: CREATE_CUSTOMER,
   payload: profile,
});

export const createCustomerSuccess = (customerId) => ({
  type: CREATE_CUSTOMER_SUCCESS,
  payload: customerId,
});

export const createCustomerFailure = (error) => ({
  type: CREATE_CUSTOMER_FAILURE,
  payload: error,
});

export const getSubscriptions = () => ({
      type: GET_SUBSCRIPTIONS,
})

export const getSubscriptionsSuccess = subscriptions => {
  return {
    type: GET_SUBSCRIPTIONS_SUCCESS,
    payload: subscriptions,
  }
}

export const getSubscriptionsError = error => {
  return {
    type: GET_SUBSCRIPTIONS_ERROR,
    payload: error,
  }
}

export const getAccountInfo = customer_id => ({
      type: GET_ACCOUNT_INFO,
      payload: customer_id,
})

export const getAccountInfoSuccess = session => ({
    type: GET_ACCOUNT_INFO_SUCCESS,
    payload: session,
})

export const getAccountInfoError = error => {
  return {
    type: GET_ACCOUNT_INFO_ERROR,
    payload: error,
  }
}

export const getDashboard = () => ({
      type: GET_DASHBOARD,
})

export const getDashboardSuccess = dashboard => ({
    type: GET_DASHBOARD_SUCCESS,
    payload: dashboard,
})

export const getDashboardError = error => {
  return {
    type: GET_DASHBOARD_ERROR,
    payload: error,
  }
}

export const addDashboardItem = item => ({
      type: ADD_DASHBOARD_ITEM,
      payload: item,
})

export const addDashboardItemSuccess = dashboard => ({
    type: ADD_DASHBOARD_ITEM_SUCCESS,
    payload: dashboard,
})

export const addDashboardItemError = error => {
  return {
    type: ADD_DASHBOARD_ITEM_ERROR,
    payload: error,
  }
}

export const deleteDashboardItem = id => ({
      type: DELETE_DASHBOARD_ITEM,
      payload: id
})

export const deleteDashboardItemSuccess = dashboard => ({
    type: DELETE_DASHBOARD_ITEM_SUCCESS,
    payload: dashboard,
})

export const deleteDashboardItemError = error => {
  return {
    type: DELETE_DASHBOARD_ITEM_ERROR,
    payload: error,
  }
}

export const fetchUsersError = error => {
  return {
    type: GET_USERS_ERROR,
    payload: error,
  }
}
